import React from 'react';
import _ from 'lodash';
import './MUIDataTableWrapper.scss';
import { createTheme, ThemeProvider, useMediaQuery, Grid } from '@mui/material';

import MUIDataTableMobile from './MUIDataTableMobile';
import MUIDataTableDesktop from './MUIDataTableDesktop';

interface Props {
  title: string;
  columns: unknown[];
  data: unknown[];
  options: unknown;
  setExpandableRowContent?: (rowData: unknown[], rowMeta?: unknown) => React.ReactNode;
  onRowClick?: (data: unknown, tableMeta?: unknown) => void;
  excludeMobile?: boolean;
}

const MUIDataTableWrapper: React.FC<Props> = (props) => {
  const displayMobile = useMediaQuery('(max-width:959px)');

  const getMuiTheme = () =>
    createTheme({
      components: {
        MuiTableRow: {
          styleOverrides: {
            root: {
              cursor: props.onRowClick ? 'pointer' : 'auto',
            },
            footer: {
              cursor: 'auto',
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            head: {
              color: '#ffffff',
              backgroundColor: '#0268b2 !important',
            },
          },
        },
      },
    });

  const renderCorrectDataTable = () => {
    if (props.excludeMobile || !displayMobile) {
      return (
        <MUIDataTableDesktop
          title={props.title}
          columns={props.columns}
          data={props.data}
          options={props.options}
          onRowClick={props.onRowClick}
        />
      );
    }
    return (
      <MUIDataTableMobile
        title={props.title}
        columns={props.columns}
        data={props.data}
        options={props.options}
        setExpandableRowContent={props.setExpandableRowContent}
        onRowClick={props.onRowClick}
      />
    );
  };

  return (
    <ThemeProvider theme={getMuiTheme()}>{renderCorrectDataTable()}</ThemeProvider>
  );
};

export default MUIDataTableWrapper;
